export function CamelToKebabCase(stringToConvert: string): string {
    return stringToConvert.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}